import React from 'react';
import Select from './../Select';
import {get, set} from "../../../utils/dotutils";
import isEqual from 'lodash-es/isEqual';
import {sendRequest} from "../../../utils/request";

let locations = null;

class PersonalPickUpControl extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            locations: locations
        }
    }

    componentDidMount() {
        if (!this.state.locations) {
            this.loadValues();
        }
    }

    loadValues = async () => {
        const response = await sendRequest({
            option: "componentlist",
            component: "location",
            itemsperpage: 0,
            filter: [
                {
                    field: "roles.optionid",
                    value: 1
                }
            ]
        });
        locations = response.items;
        this.setState({
            locations: response.items
        }, () => {
            const m = {"contact": "name", "email": "email", "telnum": "telnum"};
            let i = 0;
            const v = {...this.props.value};
            Object.keys(m).map((ff) => {
                const field = m[ff];
                if (!(this.props.value && get(this.props.value,ff))) {
                    i++;
                    set(v, ff, get(this.props.user,field));
                }
            });
            if (locations.length === 1) {
                const value = (this.props.value && this.props.value.location) || {};
                if (value.id + "" !== "" + locations[0].id) {
                    i++;
                    set(v, "location", {...locations[0]});
                }
            }
            if (i > 0) {
                this.props.saveChanges((this.props.name || 'shipping'), v);
            }
        });
    }

    setFieldValue = (field, value) => {
        this.props.saveChanges && this.props.saveChanges(field, value);
    }

    getProps = (name) => {
        let props = {};
        if (this.props.getFieldProps) {
            props = this.props.getFieldProps((this.props.name ? this.props.name + '.' : '') + name);
        }
        const disabled = this.props.disabled;//Array.isArray(this.props.disabled) ? this.props.disabled : [this.props.disabled];
        props.disabled = (!Array.isArray(disabled) && disabled) || (Array.isArray(disabled) && disabled.indexOf(name) !== -1);
        return props;
    }

    getFields = () => {
        return {
            ...this.props.fields,
            address: <div className="col-sm-12">
                <Select
                    objectValue={false}
                    {...this.getProps("location")}
                    autoSelect={true}
                    options={this.state.locations}
                    component="location"
                    valueKey="id"
                    labelKey="name"
                    storeType="local"
                    name="location"
                    filter={[
                        {
                            field: "roles.optionid",
                            value: 1
                        }
                    ]}
                    value={(this.props.value && this.props.value.location) || null}
                    label="Átvevőhely"
                    saveChanges={this.setFieldValue}
                />
            </div>
        }
    }

    getLayout = () => {
        return this.getFields().address;
    }

    render() {
        return this.props.layout ? this.props.layout(this.getFields()) : this.getLayout();
    }

}

export default PersonalPickUpControl;